import { useState } from 'react';
import { TabOptions } from 'types/Benchmark';

export const tabOptions: string[] = [
  TabOptions.Benchmarks,
  // TabOptions.CalculationTrace,
  // TabOptions.UploadFiles,
  TabOptions.Admin
];

export const useTabs = () => {
  const [activeTab, setActiveTab] = useState(TabOptions.Benchmarks);

  const showBenchmarks = activeTab === TabOptions.Benchmarks;
  const showAdmin = activeTab === TabOptions.Admin;
  const showUpload = activeTab === TabOptions.UploadFiles;

  return {
    activeTab,
    tabOptions,
    showAdmin,
    showUpload,
    showBenchmarks,
    setActiveTab
  }
};